module.exports = __webpack_public_path__ + "img/icon_quick.b417ae40.svg";